import { ProductFormatter } from '@/services/formatter/__f.product'
import type {
  ProductCollectionResponse,
  ProductQueryParams,
  ProductResponseFormatted,
  X2CoolCashResponse,
} from '@/types/product'
import { ApiResponse, httpClient } from './http-client'

export const __cCollectionService = {
  async getProductsBySlug(
    params: ProductQueryParams
  ): Promise<ProductResponseFormatted> {
    try {
      const response = await httpClient.V3.get<ProductCollectionResponse>(
        `/collections/list-products/${params.slug}`,
        {
          params: {
            ...params,
            visibility: true,
          },
        }
      )

      // Format the response data directly in the service
      return ProductFormatter.reFormatProductsByCollectionResponse(response)
    } catch (error) {
      console.error('Failed to fetch products by slug:', error)
      throw new Error(`Failed to fetch products for collection ${params.slug}`)
    }
  },

  async getX2CoolCashProducts() {
    //TODO: set theo collection nhưng BE lại trả về toàn bộ product_id thuộc các collection
    try {
      const { data } =
        await httpClient.V3.get<ApiResponse<X2CoolCashResponse>>(
          '/get-sale-coolcash'
        )
      return data
    } catch (error) {
      console.error('Failed to fetch x2 coolcash products:', error)
      throw new Error('Failed to fetch x2 coolcash products')
    }
  },
}
